import { selectPropertyAddress } from '@/editor/store/reducers/property-info.slice';
import { mapService } from '@/editor/components/googleMaps/google-map-service';
import { useCallback, useEffect, useState } from 'react';
import { CircleRadius } from '@/editor/components/googleMaps/GoogleAutocomplete';
import { useAppDispatch, useAppSelector } from '@/store/hooks/redux';
import { addPlace, selectPlaces } from '@/editor/store/reducers/adSet-step.slice';

export const useInitializeCircles = (mapLoaded: boolean) => {
  const [initialized, setInitialized] = useState<boolean>(false);
  const propertyAddress = useAppSelector(selectPropertyAddress);
  const map = mapService.getMap();
  const dispatch = useAppDispatch();
  const places = useAppSelector(selectPlaces);

  const onUnmount = useCallback(() => {
    console.log('Map unmounting via onUnmount callback');
    cleanupMap();
  }, []);

  const cleanupMap = useCallback(() => {
    if (initialized) {
      setInitialized(false);
      mapService.setMap(null);
    }
  }, []);

  useEffect(() => {
    console.log('useInitializeCircles');
    const loadInitialCircle = () => {
      if (!map) {
        console.info(`Error loading circles: map not initialized `);
        return;
      }

      if (places.length > 0) {
        console.info('places already set');
        return;
      }

      if (!mapLoaded) return;

      const geocoder = new google.maps.Geocoder();
      geocoder
        .geocode({
          address: propertyAddress.toLowerCase(),
        })
        .then((resp) => {
          if (!resp.results || resp.results.length === 0) return;
          const place = resp.results[0];
          const placeName = place.formatted_address.substring(0, place.formatted_address.indexOf(','));
          const countryCode = place.address_components.find((el) => el.types.includes('country'))?.short_name;

          const circle = mapService.createCircle(
            place.geometry.location.lat(),
            place.geometry.location.lng(),
            CircleRadius.META,
            placeName
          );

          if (!circle) {
            console.error('Error: Circle creation Failed');
            return;
          }

          dispatch(
            addPlace({
              address: placeName,
              center: { lat: circle.getCenter()?.lat()!, lng: circle.getCenter()?.lng()! },
              radius: circle?.getRadius(),
              countryCode: countryCode ?? null,
            })
          );

          mapService.getMap()?.panTo(circle?.getCenter()!);
          setInitialized(true);
        })
        .catch((e) => console.log(e));
    };
    if (propertyAddress && map) {
      loadInitialCircle();
    }

    return () => {
      console.log('cleanup');
      cleanupMap();
    };
  }, [propertyAddress, mapLoaded]);

  return { initialized, setInitialized, onUnmount };
};
